"use strict";

const Vue = window.Vue;
const readPageData = require('./page-data');
const LoginApp = require('./pages/LoginApp.vue').default || require('./pages/LoginApp.vue');

new Vue({
    render: function(createElement) {
        return createElement(LoginApp, {
            props: {
                initialData: readPageData('login-data')
            }
        });
    }
}).$mount('#login-app');



// WEBPACK FOOTER //
// ./resources/assets/js/login.js